import { render, staticRenderFns } from "./KueppersbuschLogo.vue?vue&type=template&id=0c965d0a&scoped=true&"
var script = {}
import style0 from "./KueppersbuschLogo.vue?vue&type=style&index=0&id=0c965d0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c965d0a",
  null
  
)

export default component.exports